module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIQAAABUAQMAAAB5tA3LAAAABlBMVEVHcExcXV8OTTz5AAAAAXRSTlMAQObYZgAAAB9JREFUOMtj+I8GPjAMD5HhCkbjazS+RuNrNL5IFAEAsJAqLhuNrLAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tbm/sidebar-gray.png
// module id = G26b
// module chunks = 40